import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-graph-node-addfield",
  "use": "icon-graph-node-addfield-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"icon-graph-node-addfield\"><g style=\"mix-blend-mode:passthrough\"><path d=\"M2,0C0.895431,0,0,0.895431,0,2L0,12C0,13.1046,0.895431,14,2,14L12,14C13.1046,14,14,13.1046,14,12L14,2C14,0.895431,13.1046,0,12,0L2,0ZM6,3L8,3L8,6L11,6L11,8L8,8L8,11L6,11L6,8L3,8L3,6L6,6L6,3Z\" fill-rule=\"evenodd\" fill=\"currentColor\" fill-opacity=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol